import { composeIO } from 'react-compose-io'
import { regularizacaoCiclosEfetivacaoIO } from './RegularizacaoCiclosEfetivacao.IO'
import { RegularizacaoCiclosEfetivacaoView } from './RegularizacaoCiclosEfetivacao.View'

export const RegularizacaoCiclosEfetivacao = composeIO(RegularizacaoCiclosEfetivacaoView, regularizacaoCiclosEfetivacaoIO)
